export default __webpack_public_path__ + "static/media/rapidsense_notext.b677f7a2.svg";